import { Component } from '@angular/core';

@Component({
  selector: 'app-dots-horizontal-icon',
  templateUrl: './dots-horizontal-icon.component.html',
  styleUrl: './dots-horizontal-icon.component.scss',
})
export class DotsHorizontalIconComponent {}
